import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { useLanguage } from "src/hooks/useLanguage";
import LanguageSwitcher from "src/components/LanguageSwitcher";
import { sendResetPasswordEmail } from "src/services/AuthenticationAPIs";

const Resetpassword: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  useLanguage(); // Initialize RTL support
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<string>("");

  // Regex to validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);
  const handleSendEmail = async (
    e: React.FormEvent<HTMLButtonElement>
  ): Promise<void> => {
    e.preventDefault();

    if (!emailRegex.test(email)) {
      setEmailError(
        t("forgotPassword.invalidEmailFormat")
      );
      return;
    }

    setEmailError(""); // Clear any previous error
    setLoading(true); // Set loading state
    try {
      localStorage.setItem("email", email);
      const data = await sendResetPasswordEmail(email);
      setLoading(false);

      if (data.status) {
        message.success(
          data.message || t("forgotPassword.resetLinkSent")
        );
        setTimeout(() => {
          navigate("/forgot-password/confirmation" , { state: { from: "forgot-password" } });
        }, 2000);
      } else {
        message.error(data.message || t("forgotPassword.genericError"));
      }
    } catch {
      setLoading(false);
      message.error(t("forgotPassword.connectionError"));
    }
  };

  return (
    <>
      <div className="reset-pass-bg" style={{ backgroundImage: "url(/Icons/forget-password-bg.svg)" }}>
        <div className="logo-wrapper">
          <img src="/images/DpLogo.png" className="logo-design" alt="img" />
          <LanguageSwitcher />
        </div>
        <div className="app">
          <div className="signup-internal-container">
            <form className="formdesign">
              <img src="/images/userlock.png" className="user-lock" alt="userlock" />
              <h2 className="Reset-password">{t("forgotPassword.resetPassword")}</h2>
              <p className="Reset-detail">
                {t("forgotPassword.enterRegisteredEmail")}
              </p>
              <div className="input-container">
                <label>
                  {t("forgotPassword.emailAddress")}
                  <input
                    required
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className={emailError ? "input-error" : ""}
                    disabled={loading}
                    type="email"
                  ></input>
                  <div className="error-message">{emailError}</div>
                </label>
              </div>
              <button
                className="button-otp"
                onClick={e => handleSendEmail(e)}
                disabled={loading}
              >
                {loading ? t("forgotPassword.sending") : t("forgotPassword.sendEmail")}
              </button>

              <p className="signup-page-text viewTerms_text">
                {t("forgotPassword.rememberPassword")}&nbsp;
                <a href="/log-in">{t("forgotPassword.signIn")}</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Resetpassword;
